import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';

@Component({
  selector: 'app-branding-header',
  imports: [],
  templateUrl: './branding-header.html',
  styleUrl: './branding-header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandingHeader {
  primaryColor = input<string | null>(null);
  headerImage = input<string | null>(null);
  /** Switches the header strapline from "Sign up" to "Renewal" for renewal LOAs. */
  isRenewal = input<boolean>(false);

  strapline = computed(() => this.isRenewal() ? 'Renewal' : 'Sign up');
}
